import './UserAvatar.css'

interface UserAvatarProps {
  name?: string
  email?: string
  displayName?: string
  photoUrl?: string
  onClick?: () => void
  loading?: boolean
  size?: 'small' | 'medium' | 'large'
}

export function UserAvatar({ name, email, displayName, photoUrl, onClick, loading, size = 'medium' }: UserAvatarProps) {
  const initial = name?.charAt(0).toUpperCase() || 
                  email?.charAt(0).toUpperCase() || 
                  displayName?.charAt(0).toUpperCase() || 
                  'U'

  return (
    <div 
      className={`user-avatar ${size} ${onClick ? 'clickable' : ''}`}
      onClick={onClick}
      title={name || email || displayName}
    >
      {loading ? (
        <div className="avatar-spinner"></div>
      ) : photoUrl ? (
        <img src={photoUrl} alt={name || 'User'} className="avatar-image" onError={(e) => { e.currentTarget.style.display = 'none'; }} />
      ) : (
        initial
      )}
    </div>
  )
}
